define([
    "base/utils/iamHttpService",
    "language/resource",
    "authui/iamUtils",
    "authui/iamEnv",
    "base/utils/preVerifycodeUtil",
    "base/utils/cookie",
    "base/utils/utility",
],
function (iamHttpService, i18n, iamUtils, iamEnv, perVerifycodeUtil, cookieOp, utils) {
    "use strict";
    var casLoginErrorCtrl = function ($scope, $sce, $filter, $interval, $timeout) {
        document.title = i18n("titles.login");
        $scope.i18n = i18n;
        $scope.systemErrorLink = "caslogin_system_error_link";
        $scope.accountErrorLink = iamUtils.CONFIG.helpCenterUrl + i18n("hwId.casLogin.accountErrorUrl");
        $scope.turkeyErrorLink = iamUtils.CONFIG.cbcRegUrlIntl + "&hwcloud=1";
        $scope.hwidLogoutLink = "https://id1.cloud.huawei.com/AMW/logout";

        $scope.cssFile = getCssFile();

        $scope.systemErrorMsgObj = ["400","408"];
        $scope.loginErrorMsgObj = ["404", "500"];
        $scope.externalMsgObj = ["401"];
        $scope.turkeyMsgObj = ["4011"];
        $scope.inactivatedMsgObj = ["402", "403"]; //402无邮箱未激活 403有邮箱未激活
        $scope.inactivatedHwidMsgObj = ["441", "442"]; //华为帐号绑定的华为云 441有邮箱未激活 442无邮箱未激活 
        $scope.accessErrorMsgObj = ["409"];

        $scope.model = {
            isMobile: window.outerWidth > 375 ? false : true,
            errorType: "",
            errorTitle: "",
            errorContent: "",
            errorLinkTxtPre: "",
            errorLinkTxt: "",
            errorLink: "",
            loginBtnTxt: "",
            loginBtnClick: "",
        };

        function getCssFile() {
            // 样式文件加载
            var cssFileArr = {
                "zh-cn": "/authui/public/custom/css/casLoginError.css",
                "en-us": "/authui/public/custom/css/casLoginError.css",
                "es-us": "/authui/public/custom/css/casLoginError.css",
                "pt-br": "/authui/public/custom/css/casLoginError.css"
            }
            return cssFileArr[window.language];
        }

        function initPage() {
            var errorCode = iamUtils.getUrlParams()["errorCode"];
            var service = iamUtils.getUrlParams()["service"];
            if(errorCode && $scope.systemErrorMsgObj.indexOf(errorCode) > -1){
                $scope.model.errorType = "systemError";
                $scope.model.errorTitle = i18n('hwId.casLogin.systemError');
                $scope.model.errorContent = i18n('hwId.casLogin.systemErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('hwId.refresh');
                if (errorCode === "408") {
                    $scope.model.loginBtnClick = function () {
                        window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                    }
                } else {
                    $scope.model.loginBtnClick = function () {
                        iamUtils.redirect2Login();
                    }
                }
            }else if(errorCode && $scope.loginErrorMsgObj.indexOf(errorCode) > -1){
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.accountError');
                $scope.model.errorContent = i18n('hwId.casLogin.accountErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = i18n('hwId.casLogin.accountErrorLink');
                $scope.model.errorLink = $scope.accountErrorLink;
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function(){
                    window.location.href = $scope.hwidLogoutLink + "?service=https://"+'auth.huaweicloud.com'+"/authui/login.html";
                }
            }else if(errorCode && $scope.externalMsgObj.indexOf(errorCode) > -1){
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.accountExternalErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = $scope.accountErrorLink;
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function(){
                    window.location.href = $scope.hwidLogoutLink + "?service=https://"+'auth.huaweicloud.com'+"/authui/login.html";
                }
            } else if (errorCode && $scope.turkeyMsgObj.indexOf(errorCode) > -1) {
                $scope.model.errorType = "accountError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = iamUtils.i18nFormat(i18n("hwId.casLogin.accountTurkeyErrorLink"), $scope.turkeyErrorLink);
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function () {
                    window.location.href = $scope.hwidLogoutLink + "?service=https://" + 'auth.huaweicloud.com' + "/authui/login.html";
                }
            }else if(errorCode && $scope.inactivatedMsgObj.indexOf(errorCode) > -1){
                if(errorCode === "403"){
                    $scope.model.errorType = "inactivatedError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedErrorDesc');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('hwId.upgradeErrorBtn');
                    $scope.model.loginBtnClick = function(){
                        iamUtils.redirect2Login();
                    }
                } else {
                    $scope.model.errorType = "inactivatedError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.accountError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedErrorDesc.noEmail');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('goLogin.hws');
                    $scope.model.loginBtnClick = function(){
                        iamUtils.redirect2Login();
                    }
                }
            }else if(errorCode && $scope.inactivatedHwidMsgObj.indexOf(errorCode) > -1){
                if(errorCode === "441"){
                    $scope.model.errorType = "inactivatedHwidError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedHwidError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedHwidErrorDesc');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('hwId.upgradeErrorBtn');
                    $scope.model.loginBtnClick = function(){
                        window.location.href = $scope.hwidLogoutLink + "?service=https://"+'auth.huaweicloud.com'+"/authui/login.html";
                    }
                } else {
                    $scope.model.errorType = "inactivatedHwidError";
                    $scope.model.errorTitle = i18n('hwId.casLogin.inactivatedHwidError');
                    $scope.model.errorContent = i18n('hwId.casLogin.inactivatedHwidErrorDesc.noEmail');
                    $scope.model.errotLinkTxtPre = "";
                    $scope.model.errotLinkTxt = "";
                    $scope.model.errorLink = "";
                    $scope.model.loginBtnTxt = i18n('goLogin.hws');
                    $scope.model.loginBtnClick = function(){
                        window.location.href = $scope.hwidLogoutLink + "?service=https://"+'auth.huaweicloud.com'+"/authui/login.html";
                    }
                }
            }else if(errorCode && $scope.accessErrorMsgObj.indexOf(errorCode) > -1){
                $scope.model.errorType = "accessError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.accessErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function(){
                    window.location.href = $scope.hwidLogoutLink + "?service=https://"+'auth.huaweicloud.com'+"/authui/login.html";
                }
            } else {
                $scope.model.errorType = "loginError";
                $scope.model.errorTitle = i18n('hwId.casLogin.loginError');
                $scope.model.errorContent = i18n('hwId.casLogin.loginErrorDesc');
                $scope.model.errotLinkTxtPre = "";
                $scope.model.errotLinkTxt = "";
                $scope.model.errorLink = "";
                $scope.model.loginBtnTxt = i18n('goLogin.hws');
                $scope.model.loginBtnClick = function(){
                    iamUtils.redirect2Login();
                }
            }
            $scope.model.errorContent = $sce.trustAsHtml($scope.model.errorContent);
        }

        // 页面初始化
        initPage();

    };

    casLoginErrorCtrl = ["$scope", "$sce", "$filter", "$interval", "$timeout", casLoginErrorCtrl];    var casLoginErrorModule = angular.module('authui.config');
    casLoginErrorModule.controller('authui.casLoginError.ctrl', casLoginErrorCtrl);

    return casLoginErrorCtrl;
});



// WEBPACK FOOTER //
// ./public/hws/js/casLoginError/controllers/casLoginErrorController.js